package com.downdogapp.client.controllers

import com.downdogapp.client.AppPage
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.AppType
import com.downdogapp.client.api.RedeemGiftRequest
import com.downdogapp.client.api.RedeemGiftResponse
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.views.RedeemGiftView

class RedeemGiftViewController(val code: String) : ViewController() {

  val tiles = MANIFEST.membershipConfig.singleAppTiles

  override val view = RedeemGiftView(this)

  fun redeemGift() {
    showSpinner()
    Network.post(RedeemGiftRequest(code = code)) { json ->
      hideSpinner()
      val response = json?.let { RedeemGiftResponse.Companion.fromJson(it) }

      if (response != null) {
        if (response.success) {
          response.redirectUrl?.let {
            AppPage.goTo(url = it)
          }
          ?: App.alert(message = response.message) {
            App.goHomeOrOpenApp()
          }
        } else {
          App.alert(message = response.message)
        }
      } else {
        App.alertNoInternet()
      }
    }
  }

  fun cancel() {
    view.showSpinner()
    App.goHomeOrOpenApp()
  }

  fun showSpinner() = view.showSpinner()
  fun hideSpinner() = view.hideSpinner()

  fun getImage(appType: AppType) =
    when (appType) {
      AppType.ORIGINAL -> Images.PURCHASE_TILE_ACTIVE_ORIGINAL
      AppType.INTRO, AppType.SEVEN, AppType.PRENATAL -> null
      AppType.HIIT -> Images.PURCHASE_TILE_ACTIVE_HIIT
      AppType.BARRE -> Images.PURCHASE_TILE_ACTIVE_BARRE
      AppType.MEDITATION -> Images.PURCHASE_TILE_ACTIVE_MEDITATION
      AppType.RUNNING -> Images.PURCHASE_TILE_ACTIVE_RUNNING
      AppType.BREATHING -> Images.PURCHASE_TILE_ACTIVE_BREATHING
      AppType.PILATES -> Images.PURCHASE_TILE_ACTIVE_PILATES
    }
}
